import { useContext } from "react";

import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { PRIVATE_ROUTES } from "../../../../../../../../constants";
import {
  MemberCertification,
  MemberCertificationStatus,
} from "../../../../../../../../models/member";
import {
  MemberAvailability,
  MemberAvailabilityAllDayAbsence,
  MemberAvailabilityPartialAbsence,
} from "../../../../../../../../models/members/member.availability";
import { MemberAvailabilityStatus } from "../../../../../../../../util/enums/members";
import { MemberContext } from "../context";
import { DatesByMemberAvailability, MemoryStatus } from "../types";

export const getDatesByMemberAvailability = (
  row?: MemberAvailability
): DatesByMemberAvailability => {
  let startDate: Date | null = null;
  let endDate: Date | null = null;

  if (row?.dateFrom) {
    endDate = new Date(row.dateFrom);
  }
  if (row?.dateTo) {
    startDate = new Date(row.dateTo);
  }

  return {
    startDate: startDate || new Date(),
    endDate: endDate || startDate || new Date(),
  };
};

export const getMemoryStatusByMemberAvailability = (row?: MemberAvailability): MemoryStatus => {
  const now = new Date();

  const { startDate, endDate } = getDatesByMemberAvailability(row);

  const startTime = row?.dateFrom ? new Date(row.dateFrom) : null;
  const endTime = row?.dateTo ? new Date(row.dateTo) : null;

  startDate?.setHours(0);
  startDate?.setMinutes(0);
  startDate?.setSeconds(0);

  endDate?.setHours(0);
  endDate?.setMinutes(0);
  endDate?.setSeconds(0);

  if (endTime) {
    endDate?.setHours(endTime.getHours());
    endDate?.setMinutes(endTime.getMinutes());
  }

  if (startTime) {
    startDate?.setHours(startTime.getHours());
    startDate?.setMinutes(startTime.getMinutes());
  }

  const data: MemoryStatus = {
    completed: false,
    cancelled: false,
    inProgress: false,
    planned: false,
  };

  if (row?.status?.toLowerCase() === MemberAvailabilityStatus.CANCELLED.toLowerCase()) {
    return { ...data, cancelled: true };
  }

  if (endDate && now.getTime() > endDate.getTime()) {
    return { ...data, completed: true };
  }

  if (startDate && now.getTime() < startDate.getTime()) {
    return { ...data, planned: true };
  }

  return { ...data, inProgress: true };
};

export function useActions() {
  const { member, handleUpdateMember, ...rest } = useContext(MemberContext);
  const history = useHistory<{ tab: string; tabPeople: string; isView?: boolean }>();
  const { t: translate } = useTranslation();

  const onAddNewAvailability = (
    data: MemberAvailabilityAllDayAbsence | MemberAvailabilityPartialAbsence
  ) => {
    handleUpdateMember("availabilities", [...(member?.availabilities || []), data]);
  };

  const onApproveCertification = (data: MemberCertification) => {
    const certifications = member?.certifications;

    if (certifications?.length) {
      const index = certifications.findIndex((row) => row.id && row.id === data.id);

      if (index !== -1 && certifications[index]) {
        certifications[index].isApproved = true;
        certifications[index].status = MemberCertificationStatus.APPROVED;

        handleUpdateMember("certifications", certifications);
      }
    }
  };

  // const onUploadCertificationFile = (data: MemberCertification, file: FileData) => {
  //   const certifications = member?.certifications;

  //   if (certifications?.length) {
  //     const index = certifications.findIndex(
  //       (row) =>
  //         (row.id && row.id === data.id) ||
  //     );

  //     if (index !== -1 && certifications[index]) {
  //       certifications[index].file = {
  //         ...(certifications[index].file || {}),
  //         filename: file.filename,
  //         data: {
  //           type: file.fileType,
  //           data: file
  //         }
  //       };

  //       handleUpdateMember("certifications", certifications);
  //     }
  //   }
  // };

  const onAddNewCertification = (data: MemberCertification) => {
    handleUpdateMember("certifications", [...(member?.certifications || []), data]);
  };

  const onBackToMembersTab = () => {
    const state = history.location.state || {
      tab: translate("people"),
      tabPeople: translate("members"),
    };

    history?.push({
      pathname: PRIVATE_ROUTES.SETTINGS,
      state,
    });
  };

  return {
    member,
    handleUpdateMember,
    onAddNewAvailability,
    onBackToMembersTab,

    onApproveCertification,
    onAddNewCertification,
    ...rest,
  };
}
